<script setup lang="ts">
import { mapSocialIcon } from "@/utils/map-social-icon";

defineProps<{
  profiles: Array<{ url: string } | null>;
}>();
</script>

<template>
  <div class="flex gap-1 text-center justify-center md:justify-start">
    <Button
      v-for="(profile, key) in profiles" :key="key"
      variant="link"
      size="icon-lg"
      as-child
    >
      <a :href="profile!.url">
        <span :class="`${mapSocialIcon(profile!.url)} size-7 text-primary-foreground`" />
      </a>
    </Button>
  </div>
</template>
